var map = {
	"./courseCenter/course.router.js": "2863",
	"./coursePlay/coursePlay.router.js": "8dbe",
	"./dynamic/dynamic.router.js": "8eea",
	"./entrance/entrance.router.js": "a5fe",
	"./error/error.router.js": "bbc8",
	"./exam/exam.router.js": "1acc",
	"./gpt/gpt.router.js": "decb",
	"./home/home.router.js": "f5f7",
	"./information/information.router.js": "b53b",
	"./learn/learn.router.js": "d997",
	"./lecturer/lecturer.router.js": "c080",
	"./operationHomeWork/operationHomeWork.router.js": "e452c",
	"./order/order.router.js": "c120",
	"./personal/personal.router.js": "b843",
	"./practice/practice.router.js": "4e87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f700";